'use client'
import React, { useEffect, useState } from 'react'
import { Button, Card, CardContent, CircularProgress } from '@mui/material'
import BuildIcon from '@mui/icons-material/Build'
import CommonApi from '../api'

const MaintenanceMode = () => {
  const [checking, setChecking] = useState(true)

  const handleGetTheme = async () => {
    try {
      const resp = await CommonApi({
        method: 'get',
        path: `theme`
      })

      if (resp.data) {
        window.location.href = '/'
        return
      }
    } catch (err) {
    } finally {
      setChecking(false)
    }
  }

  useEffect(() => {
    handleGetTheme()
  }, [])

  if (checking) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-200 dark:from-gray-900 dark:to-gray-800">
        <CircularProgress color="primary" />
      </div>
    )
  }

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-50 to-gray-200 dark:from-gray-900 dark:to-gray-800 p-4">
      <Card className="max-w-md w-full shadow-xl rounded-2xl">
        <CardContent className="flex flex-col items-center text-center space-y-6 p-8">
          <div className="p-4 bg-blue-100 dark:bg-blue-900 rounded-full">
            <BuildIcon className="text-blue-600 dark:text-blue-300" fontSize="large" />
          </div>

          <h1 className="text-2xl font-bold text-gray-800 dark:text-gray-100">Under Maintenance</h1>

          <p className="text-gray-600 dark:text-gray-300 text-sm">
            We are currently experiencing a technical challenge that we are working to resolve
            immediately. Full system functionality will be restored as soon as possible.
          </p>

          <Button
            variant="contained"
            color="primary"
            onClick={() => window.location.reload()}
            className="!rounded-2xl !px-6 !py-2"
          >
            Refresh
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}

export default MaintenanceMode
